import { createAction, props } from '@ngrx/store';

export const initFeatureFlagSuccess = createAction('[FeatureFlag] init', props<{ featureFlags: string[] }>());
